import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { useDispatch, useSelector } from 'react-redux';
import { clear } from '../../actions/cart';
import { ReloadHotels } from '../../actions/hotels';
import { ReloadPackages } from '../../actions/packages';

import {
    ItemRanOutOfStockDialog,
} from '../../components/dialogs/ItemRanOutOfStockDialog';
import ModalDialog from '../../components/dialogs/ModalDialog';

import { FullScreenLoader } from '../../components/FullScreenLoader';

import isCheckoutPage from '../../utils/is-checkout-page';
import { NavigationController } from './controllers/NavigationController';
import {
    RemoveGiftcardController,
} from './controllers/RemoveGiftcardController';

import StockController from './controllers/stock-controller';
import TimeController from './controllers/time-controller';

function ApplicationBridge() {
    const [isOutOfStock, setIsOutOfStock] = useState(false);
    const [hasTickets, setHasTickets] = useState(false);
    const [hasHotels, setHasHotels] = useState(false);
    const [hasTimedOut, setHasTimedOut] = useState(false);

    const stockCheckEnabled = useSelector(state => state.app.stock_check_enabled);
    const selectedPackage = useSelector(state => state.packages.selected_package);
    const startTime = useSelector(state => state.cart.start_time);
    const loadingCart = useSelector(state => state.cart.loading_cart);
    const loadingEmptyCart = useSelector(state => state.cart.loading_empty_cart);
    const eventUrl = useSelector(state => state.cart.event_url);

    const confirmedPackage = useSelector(state => state.cart.confirmed_package);
    const food = useSelector(state => state.cart.food);
    const confirmedFood = useSelector(state => state.cart.confirmed_food);
    const optionalHotel = useSelector(state => state.cart.optional_hotel);
    const withoutHotel = useSelector(state => state.cart.without_hotel);
    const confirmedHotel = useSelector(state => state.cart.confirmed_hotel);
    const requireDinner = useSelector(state => state.cart.require_dinner);
    const confirmedDinner = useSelector(state => state.cart.confirmed_dinner);

    const dispatch = useDispatch();

    function onStockCheckFailure(hasTickets, hasHotels) {
        setIsOutOfStock(true);
        setHasTickets(hasTickets);
        setHasHotels(hasHotels);
    }

    function onTimeout() {
        setHasTimedOut(true);
    }

    function onClickOutOfStockDialog() {
        if (document.location.href !== eventUrl) {
            onClickTimeoutDialog();
        } else {
            if (hasTickets) {
                onResetHotels();
            } else {
                onResetTickets();
            }
        }
    }

    async function onClickTimeoutDialog() {
        await dispatch(clear());

        localStorage.removeItem('persist:cart');
        if (eventUrl != null) {
            document.location.href = eventUrl;
        } else {
            if (isCheckoutPage()) {
                document.location.href = '/';
            } else {
                document.location.reload();
            }
        }
    }

    function onResetHotels() {
        dispatch(ReloadHotels());

        setIsOutOfStock(false);
    }

    function onResetTickets() {
        dispatch(ReloadPackages());

        setIsOutOfStock(false);
    }

    return (
        <>
            <RemoveGiftcardController />
            <NavigationController
                confirmedPackage={confirmedPackage}
                selectedPackage={selectedPackage}
                foodTicket={food}
                confirmedFood={confirmedFood}
                optionalHotel={optionalHotel}
                withoutHotel={withoutHotel}
                confirmedHotel={confirmedHotel}
                requireDinner={requireDinner}
                confirmedDinner={confirmedDinner}
            />
            <StockController
                active={stockCheckEnabled && !isOutOfStock}
                onFailure={onStockCheckFailure}
            />
            <TimeController
                startTime={startTime}
                onTimeout={onTimeout}
            />
            <ItemRanOutOfStockDialog
                visible={isOutOfStock}
                hasTickets={hasTickets}
                hasHotels={hasHotels}
                onClick={onClickOutOfStockDialog}
            />
            <ModalDialog
                visible={hasTimedOut}
                primaryAction={onClickOutOfStockDialog}
                secondaryAction={onClickOutOfStockDialog}
                type={'clock'}
                modalHeader={'Tidsgränsen är nådd'}
                modalBody={'Din bokningstid är nu slut. Gör om stegen om du önskar att boka det här evenemanget.'}
                ctaButtonText={'Börja om bokning'}
            />
            <FullScreenLoader
                visible={loadingCart}
                message="Kontrollerar din bokning och laddar kassan för betalning..."
            />
            <FullScreenLoader
                visible={loadingEmptyCart}
                message="Tömmer din varukorg"
            />
        </>
    );
}

export default hot(module)(ApplicationBridge);
